enum MarketExtensionConfigsTypes {
  LOCALES = 'locales',
  PAGE_CONFIGS = 'pageConfigs',
  REDIRECTS = 'redirects',
  DYNAMIC_REWRITES = 'dynamicRewrites',
  DYNAMIC_REDIRECTS = 'dynamicRedirects',
}

export default MarketExtensionConfigsTypes;
